// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xTBli","topWrap":"styles_topWrap__5uz9_","iconWrap":"styles_iconWrap__k_acR","title":"styles_title__hx6hf","list":"styles_list__Lw6kO","name":"styles_name__Aj1hj","meter":"styles_meter__gRrrT","poi":"styles_poi__rjfz7","notAvailablePoi":"styles_notAvailablePoi__fcRBg"};
module.exports.__checksum = "d76fe0c2c3be"
